import React from 'react';
import I18n from './I18n';

const Button = React.createClass({
  propTypes: {
    disabled: React.PropTypes.bool
  },

  handleClick: function () {
    this.props.onClick && this.props.onClick();
  },

  render: function () {
    return (
      <button type={this.props.type} className={this.props.className} disabled={this.props.disabled}
              onClick={this.handleClick}><I18n message={this.props.text}/></button>
    );
  }
});

export default Button;



// WEBPACK FOOTER //
// ./src/js/Component/Button.jsx